export const SYSTEMS = {
  ARIA: 'aria',
  VTM5: 'vtm5',
};

const SUBDOMAINS = {
  vtm: SYSTEMS.VTM5,
};

const isKnownSystem = (value) => Object.values(SYSTEMS).includes(value);

/**
 * Détermine le système de jeu de l'application.
 * Priorité : variable d'env REACT_APP_GAME_SYSTEM (dev local), puis sous-domaine
 * (vtm.praythedice.com, vtm.localhost), sinon Aria.
 * @param {String} hostname window.location.hostname
 * @param {String} [forcedSystem] valeur de REACT_APP_GAME_SYSTEM
 * @returns {String} une valeur de SYSTEMS
 */
export const detectSystem = (hostname = '', forcedSystem) => {
  if (isKnownSystem(forcedSystem)) {
    return forcedSystem;
  }
  const subdomain = hostname.toLowerCase().split('.')[0];
  return SUBDOMAINS[subdomain] || SYSTEMS.ARIA;
};

/**
 * Les campagnes créées avant le multi-système n'ont pas de champ `system` : ce sont des campagnes Aria.
 * @param {{system?: String}} campaign
 * @returns {String}
 */
export const getCampaignSystem = (campaign) => (campaign && campaign.system) || SYSTEMS.ARIA;

export const isCampaignOfSystem = (campaign, system) => getCampaignSystem(campaign) === system;

/**
 * Adresse d'un système : le domaine principal pour Aria, le sous-domaine pour les autres.
 * Garde le protocole et le port courants (vtm.localhost:3000 en dev).
 * @param {String} system une valeur de SYSTEMS
 * @param {Location} [location] window.location
 * @param {String} [path] chemin visé, la liste des campagnes par défaut
 * @returns {String}
 */
export const getSystemUrl = (system, location = window.location, path = '/campaigns') => {
  const subdomain = Object.keys(SUBDOMAINS).find(key => SUBDOMAINS[key] === system);
  const labels = location.hostname.toLowerCase().split('.');
  const baseLabels = (SUBDOMAINS[labels[0]] || labels[0] === 'www') ? labels.slice(1) : labels;
  const hostname = subdomain ? [subdomain, ...baseLabels].join('.') : baseLabels.join('.');
  const port = location.port ? `:${location.port}` : '';
  return `${location.protocol}//${hostname}${port}${path}`;
};
